import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as DreamIcon } from '../icons/dream-icon.svg';
import './not-found-page.scss';

const NotFoundPage: React.FC = () => {
  return (
    <div className='not-found-page'>
      <div className='not-found-logo'>
        <Link to='/'>
          <DreamIcon />
        </Link>
      </div>
      <div className='not-found-content'>
        <img
          src='/splicons/404.png'
          alt='Page not found'
          className='not-found-image'
        />
        <h1 className='not-found-title'>
          I can do nearly anything, but I can't find that
        </h1>
        <Link to='/' className='not-found-link'>
          Back to home
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
